import { useEffect, useState } from "react";
import CardC from "../../components/CustomCard/CardC";
import { Loader, toaster } from "rsuite";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputSearch from "../../components/inputs/InputSelectSearch";
import { Button, Col, Collapse, Row } from "react-bootstrap";
import getReportPDF from "../../components/reportes/pdf/getReports";
import { pdf } from "@react-pdf/renderer";
import Alert from "../../components/notification/Alert";
import ModalPDF from "../../components/Modals/ModalPDF";
import getReportExcel from "../../components/reportes/excel/getReports";
import getReportHTML from "../../components/reportes/htmlRep/getReport";
import peticionBack from "../../libs/peticiones/peticionBack";
import { reportes, tiposReporte } from "../../libs/dataSelects";

export default function Reportes() {
  const [loading, setLoading] = useState<any>({ state: false, msg: "" });
  const [reportPDF, setReportPDF] = useState<string>("");
  const [showPDF, setshowPDF] = useState<boolean>(false);
  const [reportHTML, setReportHTML] = useState<any>();
  const [showHTML, setshowHTML] = useState<boolean>(false);

  /* PDF */
  useEffect(() => {
    if (reportPDF) setshowPDF(true);
  }, [reportPDF]);

  useEffect(() => {
    if (!showPDF) setReportPDF("");
  }, [showPDF]);

  /* HTML */
  useEffect(() => {
    if (reportHTML) setshowHTML(true);
  }, [reportHTML]);

  return (
    <>
      <CardC>
        <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2">
          <h4 className="">Reportes</h4>
        </div>
        <FormReporte
          setLoading={setLoading}
          setReportePDF={setReportPDF}
          setReportHTML={setReportHTML}
          tabla={[showHTML, setshowHTML]}
        />

        <Collapse in={showHTML}>
          <div className="mt-4 mx-md-3">{reportHTML}</div>
        </Collapse>
      </CardC>

      <ModalPDF
        stateShow={[showPDF, setshowPDF]}
        title="Reporte"
        src={reportPDF}
      />

      {loading.state && (
        <Loader
          backdrop
          vertical
          style={{ zIndex: 5 }}
          size="md"
          content={loading.msg}
        />
      )}
    </>
  );
}

function FormReporte({
  setLoading,
  setReportePDF,
  setReportHTML,
  tabla,
}: {
  setLoading: any;
  setReportePDF: any;
  setReportHTML: any;
  tabla: [any, any];
}) {
  const [formatos, setFormatos] = useState(tiposReporte);
  const formSchema = Yup.object().shape({
    id: Yup.number()
      .required("Seleccione un reporte")
      .min(1, "Seleccione un reporte"),
    type: Yup.string().required("Seleccione un formato"),
  });

  const {
    handleSubmit,
    handleReset,
    handleBlur,
    setFieldValue,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: { id: 0, type: "" },
    validationSchema: formSchema,
    onSubmit: (values) => typeReport(),
    onReset: () => {},
  });

  function onChange({ target }: any) {
    setFieldValue(target.name, target.value);
    if (tabla[0]) tabla[1](false);
  }

  function typeReport() {
    if (values.type === "HTML") {
      const cmpHtml = getReportHTML(values.id, true);
      setReportHTML(cmpHtml);
    } else {
      getDataReport();
    }
  }

  async function getDataReport() {
    setLoading({state: true, msg: "Obteniendo información..."});
    const fnd = findReport();
    const route = "/reportes/" + (fnd && fnd.route ? fnd.route : values.id);
    const res = await peticionBack({}, route, "GET", false, toaster);
    setLoading({state: false, msg: ""});
    if (res) {
      generateReport(res);
    }
    setLoading({ state: false, msg: "" });
  }

  async function generateReport(data: any) {
    setLoading({ state: true, msg: "Generando reporte..." });
    try {
      switch (values.type) {
        case "PDF":
          const blobPDF = await pdf(getReportPDF(values.id, data)).toBlob();
          const urlPDF = window.URL.createObjectURL(blobPDF);
          setReportePDF(urlPDF);
          break;
        case "EXCEL":
          await getReportExcel(values.id, data);
          break;
      }
    } catch (err: any) {
      console.error(err);
      toaster.push(
        Alert({
          type: "error",
          message:
            err.cause === 404
              ? err.message
              : "Ocurrio un problema al generar el reporte",
        }),
        {
          placement: "topCenter",
        }
      );
    }
  }

  function getFormats() {
    if(!values.id) {
      setFormatos(tiposReporte);
      return;
    }
    const fnd = findReport();
    if(!fnd || !fnd.exclude) {
      setFormatos(tiposReporte);
      return;
    }
    setFieldValue("type", "");
    setFormatos(tiposReporte.filter(tr => !(fnd.exclude as string[]).includes(tr.name)));
  }

  useEffect(() => {
    getFormats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.id]);

  function findReport(){
    return reportes.find(r => r.value === values.id);
  }

  return (
    <form onSubmit={handleSubmit} onReset={handleReset}>
      <Row>
        <Col xs={12} md={6}>
          <InputSearch
            label="Reporte"
            name="id"
            value={values.id}
            error={errors.id}
            touched={touched.id}
            values={reportes}
            labelVal="label"
            valueVal="value"
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
          />
        </Col>
        <Col xs={12} md={6}>
          <InputSearch
            label="Formato"
            name="type"
            value={values.type}
            error={errors.type}
            touched={touched.type}
            values={formatos}
            labelVal="name"
            valueVal="name"
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            disabled={!values.id}
          />
        </Col>
        <Col xs={12} md={6}></Col>
      </Row>
      <div className="d-grid d-md-block text-center mt-2">
        <Button variant="primary" type="submit">
          Generar reporte
        </Button>
      </div>
    </form>
  );
}
